// sharedStyles.ts
import {css} from 'styled-components';

import TextProps from './TextProps';

export const sharedStyle = css<Partial<TextProps>>`
  color: #000000;

  &.bold {
    font-weight: 600;
  }
  &.green {
    color: #7ED057 !important;
  }
  &.black {
    color: #000 !important;
  }
  &.red {
    color: #EF5E70 !important;
  }
  &.grey {
    color: #7B7B7B !important;
  }
  &.darkGrey {
    color: #6F7080 !important;
  }
  &.white {
    color: #E9E9EA !important;
  }
  &.blue {
    color: #4C89FE !important;
  }

  ${props =>
      props.inline &&
      `
      display: inline-block;
  `}
  ${props =>
      props.newlines &&
      `
      white-space: pre-line;
  `}
  ${props =>
      props.left &&
      `
      text-align: left;
  `}
  ${props =>
      props.right &&
      `
      text-align: right;
  `}
  ${props =>
      props.black &&
      `
      color: #000;
  `}
  ${props =>
      props.grey &&
      `
      color: #7F818D;
  `}
  ${props =>
      props.red &&
      `
      color: #EF5E70;
  `}
  ${props =>
      props.blue &&
      `
      color: #4C89FE;
  `}
  ${props =>
      props.green &&
      `
      color: #7ED057;
  `}
  ${props =>
      props.darkGrey &&
      `
      color: #6F7080;
  `}
  ${props =>
      props.brightGrey &&
      `
      color: #E9E9EA;
  `}
  ${props =>
      props.white &&
      `
      color: #E9E9EA;
  `}
  ${props =>
      props.full &&
      `
      flex-basis: 100%;
  `}
`;

export const sharedBodyStyle = css<Partial<TextProps>>`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  margin: 0 10px;

  @media (min-width: 350px) {
    font-size: 8px;
  }
  @media (min-width: 750px) {
    font-size: 8px;
  }
  @media (min-width: 900px) {
    font-size: 10px;
  }
  @media (min-width: 1000px) {
    font-size: 12px;
  }
  @media (min-width: 1200px) {
    font-size: 14px;
  }
`;
